import {StyleSheet} from 'react-native';
import CommonStyles from '../../../utils/CommonStyles';

// Theme-aware styles factory (docs/DARK-MODE.md). Color-bearing CommonStyles
// spreads (white_bg, light_grey_border) are replaced with explicit themed
// values (identical in light).
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      ...CommonStyles.flex_row,
      backgroundColor: colors.surface,
      ...CommonStyles.br_16,
      ...CommonStyles.p_16,
      shadowColor: colors.shadow,
      shadowOpacity: 0.12,
      shadowRadius: 30,
      shadowOffset: {width: 0, height: 30},
    },
    imageConatiner: {
      ...CommonStyles.p_16,
      ...CommonStyles.bw_1,
      borderColor: colors.border,
      ...CommonStyles.br_16,
    },
    productImage: {
      height: 125,
      width: 125,
    },
    detailsConatiner: {
      ...CommonStyles.full_flex,
      ...CommonStyles.ml_16,
    },
    freeText: {
      backgroundColor: colors.backgroundMuted,
      paddingVertical: 5,
      ...CommonStyles.ph_8,
      ...CommonStyles.br_8,
      ...CommonStyles.self_start,
    },
    addContainer: {
      ...CommonStyles.flex_row,
      ...CommonStyles.mt_24,
    },
    addToCartButton: {
      width: 135,
      height: 40,
      ...CommonStyles.justify_center,
      ...CommonStyles.br_8,
      ...CommonStyles.ml_16,
    },
    addToCartButtonTitle: {
      fontSize: 14,
      lineHeight: 16,
      // Base Button title carries marginVertical: 16 — inside this card's
      // fixed 40px-high button that overflows and clips the text bottom.
      marginVertical: 0,
    },
    qtyContainer: {
      width: 135,
      height: 40,
      borderColor: colors.borderMuted,
      ...CommonStyles.br_8,
      ...CommonStyles.bw_1,
      ...CommonStyles.flex_row,
      ...CommonStyles.mr_16,
    },
    qtyTextContainer: {
      borderLeftWidth: 1,
      borderRightWidth: 1,
      borderLeftColor: colors.borderMuted,
      borderRightColor: colors.borderMuted,
      ...CommonStyles.full_flex,
      ...CommonStyles.flex_center,
    },
    arrowImgContainer: {
      width: 40,
      height: 40,
      ...CommonStyles.flex_center,
    },
    hitSlop: {
      top: 20,
      left: 20,
      bottom: 20,
      right: 20,
    },
  });

export default makeStyles;
